(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-carousel"] && !Shopify.designMode) return;
  try {
    
  class IngredientCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-carousel-track]');
      this.cards = Array.from(section.querySelectorAll('.ingredient-card'));
      this.prevBtn = section.querySelector('[data-nav="prev"]');
      this.nextBtn = section.querySelector('[data-nav="next"]');
      this.dotsContainer = section.querySelector('[data-dots]');
      this.dots = Array.from(section.querySelectorAll('[data-dot]'));
      this.addToCartBtn = section.querySelector('[data-add-to-cart]');

      this.currentIndex = 0;
      this.cardsPerView = this.getCardsPerView();
      this.maxIndex = Math.max(0, Math.ceil(this.cards.length / this.cardsPerView) - 1);

      // Drag state
      this.isDragging = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.trackContainer = section.querySelector('.ingredient-carousel__track-container');
      this.wheelTimeout = null;

      this.init();
    }

    init() {
      // Setup event listeners
      this.setupEventListeners();

      // Setup drag functionality
      this.setupDragListeners();

      // Update navigation state
      this.updateNavigation();

      // Update dots visibility
      this.updateDotsVisibility();
    }

    setupEventListeners() {
      // Navigation arrows
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Dots
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dot);
          this.goToSlide(index);
        });
      });

      // Card toggles
      this.cards.forEach(card => {
        const toggleBtn = card.querySelector('[data-toggle]');
        if (toggleBtn) {
          toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            card.classList.toggle('expanded');
          });
        }
      });

      // Add to cart
      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', () => this.addToCart());
      }

      // Window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.cardsPerView = this.getCardsPerView();
          this.maxIndex = Math.max(0, Math.ceil(this.cards.length / this.cardsPerView) - 1);
          this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
          this.updateCarousel();
          this.updateDotsVisibility();
        }, 200);
      });
    }

    setupDragListeners() {
      if (!this.trackContainer || !this.track) return;

      // Bind methods to preserve context
      this.handleMouseDown = this.dragStart.bind(this);
      this.handleMouseMove = this.drag.bind(this);
      this.handleMouseUp = this.dragEnd.bind(this);
      this.handleTouchStart = this.dragStart.bind(this);
      this.handleTouchMove = this.drag.bind(this);
      this.handleTouchEnd = this.dragEnd.bind(this);

      // Mouse events
      this.trackContainer.addEventListener('mousedown', this.handleMouseDown);
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);

      // Touch events
      this.trackContainer.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.trackContainer.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this.trackContainer.addEventListener('touchend', this.handleTouchEnd);

      // Prevent default drag behavior on images and links
      this.trackContainer.addEventListener('dragstart', (e) => e.preventDefault());

      // Wheel event for 2-finger touchpad scrolling
      this.trackContainer.addEventListener('wheel', (e) => this.handleWheel(e), { passive: false });
    }

    handleWheel(e) {
      // Detect horizontal scroll (2-finger swipe on touchpad)
      const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

      if (isHorizontalScroll && Math.abs(e.deltaX) > 10) {
        e.preventDefault();

        // Debounce wheel events
        if (this.wheelTimeout) return;

        this.wheelTimeout = setTimeout(() => {
          this.wheelTimeout = null;
        }, 300);

        if (e.deltaX > 0 && this.currentIndex < this.maxIndex) {
          // Scroll right - go next
          this.next();
        } else if (e.deltaX < 0 && this.currentIndex > 0) {
          // Scroll left - go prev
          this.prev();
        }
      }
    }

    dragStart(e) {
      // Don't start drag if clicking on toggle button
      if (e.target.closest('[data-toggle]')) return;

      this.isDragging = true;
      this.hasMoved = false;
      this.startX = this.getPositionX(e);

      // Calculate current translate from current index
      const cardWidth = this.cards[0]?.offsetWidth || 320;
      const gap = 16;
      this.prevTranslate = -(this.currentIndex * this.cardsPerView * (cardWidth + gap));

      this.track.classList.add('dragging');
      this.trackContainer.classList.add('dragging');
    }

    drag(e) {
      if (!this.isDragging) return;

      const currentX = this.getPositionX(e);
      const diff = currentX - this.startX;

      // Only consider it a drag if moved more than 5px
      if (Math.abs(diff) > 5) {
        this.hasMoved = true;
        // Prevent vertical scroll during horizontal drag
        if (e.cancelable && e.type.includes('touch')) {
          e.preventDefault();
        }
      }

      this.currentTranslate = this.prevTranslate + diff;

      // Add resistance at boundaries
      const maxTranslate = 0;
      const minTranslate = -((this.cards.length - 1) * (this.cards[0]?.offsetWidth + 16));

      if (this.currentTranslate > maxTranslate) {
        this.currentTranslate = maxTranslate + (this.currentTranslate - maxTranslate) * 0.3;
      } else if (this.currentTranslate < minTranslate) {
        this.currentTranslate = minTranslate + (this.currentTranslate - minTranslate) * 0.3;
      }

      // Apply transform directly
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    dragEnd() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.track.classList.remove('dragging');
      this.trackContainer.classList.remove('dragging');

      if (!this.hasMoved) {
        return;
      }

      const cardWidth = this.cards[0]?.offsetWidth || 320;
      const gap = 16;
      const moveThreshold = cardWidth / 4; // 25% of card width
      const diff = this.currentTranslate - this.prevTranslate;

      if (diff < -moveThreshold && this.currentIndex < this.maxIndex) {
        // Swiped left - go next
        this.next();
      } else if (diff > moveThreshold && this.currentIndex > 0) {
        // Swiped right - go prev
        this.prev();
      } else {
        // Snap back to current position
        this.updateCarousel();
      }
    }

    getPositionX(e) {
      if (e.type.includes('touch')) {
        return e.touches && e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX;
      }
      return e.pageX;
    }

    getCardsPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 1024) return 2;
      return 4;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }

    next() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateCarousel();
    }

    updateCarousel() {
      if (!this.track || this.cards.length === 0) return;

      const cardWidth = this.cards[0].offsetWidth;
      const gap = 11;
      const offset = -(this.currentIndex * this.cardsPerView * (cardWidth + gap));
      
      this.track.style.transform = `translateX(${offset}px)`;
      
      this.updateNavigation();
      this.updateDots();
    }

    updateNavigation() {
      if (this.prevBtn) {
        this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
        this.prevBtn.style.pointerEvents = this.currentIndex === 0 ? 'none' : 'auto';
      }
      
      if (this.nextBtn) {
        this.nextBtn.style.opacity = this.currentIndex === this.maxIndex ? '0.3' : '1';
        this.nextBtn.style.pointerEvents = this.currentIndex === this.maxIndex ? 'none' : 'auto';
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    }

    updateDotsVisibility() {
      // Calculate how many dot groups we need
      const totalDots = Math.ceil(this.cards.length / this.cardsPerView);
      
      // Hide dots that exceed the total needed
      this.dots.forEach((dot, index) => {
        dot.style.display = index < totalDots ? 'block' : 'none';
      });
    }

    async addToCart() {
      if (!this.addToCartBtn) return;
      
      const variantId = this.addToCartBtn.dataset.addToCart;
      const originalText = this.addToCartBtn.querySelector('span').textContent;
      
      try {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.querySelector('span').textContent = 'ADDING...';
        
        const formData = {
          'items': [{
            'id': variantId,
            'quantity': 1
          }]
        };
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        if (response.ok) {
          this.addToCartBtn.querySelector('span').textContent = 'ADDED!';
          
          // Dispatch event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Reset button after 2 seconds
          setTimeout(() => {
            this.addToCartBtn.querySelector('span').textContent = originalText;
            this.addToCartBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.addToCartBtn.querySelector('span').textContent = 'ERROR';
        setTimeout(() => {
          this.addToCartBtn.querySelector('span').textContent = originalText;
          this.addToCartBtn.disabled = false;
        }, 2000);
      }
    }
  }

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.ingredient-carousel');
    sections.forEach(section => {
      new IngredientCarousel(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
